export const contactDetails = [
    {
        title : "Chat on us",
        desc : "Our friendly team is here to help.",
        contact : "info@studynotion.com",
        image : "PiChatsFill",
    },

    {
        title : "Visit us",
        desc : "Come and say hello at our office HQ.",
        contact : "Akshya Nagar 1st Block 1st Cross, Rammurthy nagar, Bangalore-560016",
        image : "FaGlobeAsia",
    },

    {
        title : "Call us",
        desc : "Mon - Fri From 8am to 5pm",
        contact : "+123 456 7869",
        image : "PiPhoneFill",
    }
]